import { type FC } from "react";

import { Tag } from "@snapchat/snap-design-system";

import { SpecApprovalState } from "../../../../gql-generated/types";
import { Flexbox } from "../../../../shared/components";
import { DetailsBreadcrumbs } from "../../common";
import { VersionLabel } from "../../messages.generated";

import {
    ApiPageHeader,
    GreenDot,
    OrangeDot,
    approvalBadge,
    detailsHeaderContainer,
    stringsContainer,
    versionBadge,
} from "./ApiHeader.styles";

interface ApiHeader {
    apiName: string;
    approvalState: SpecApprovalState;
    version: number;
}

export const ApiHeader: FC<ApiHeader> = ({ apiName, approvalState, version }) => {
    return (
        <Flexbox justifyContent="center" className={detailsHeaderContainer}>
            <Flexbox flexDirection="column" justifyContent="center" className={stringsContainer}>
                <DetailsBreadcrumbs apiName={apiName} />
                <Flexbox flexDirection="row">
                    <ApiPageHeader>{apiName}</ApiPageHeader>
                    <Tag className={approvalBadge}>
                        {approvalState === SpecApprovalState.Approved ? <GreenDot /> : <OrangeDot />}
                        <div>{approvalState}</div>
                    </Tag>
                    <Tag className={versionBadge}>
                        <VersionLabel version={version} />
                    </Tag>
                </Flexbox>
            </Flexbox>
        </Flexbox>
    );
};
